// 選手情報を取得・整形・表示するAPI
export const playersInfoApi = () => {
  async function fetchPlayers() {
    try {
      // 表示先コンテナとチーム・年度情報の取得（デフォルトあり）
      const container = document.getElementById('players');
      if (!container) return;

      // ローカルJSONファイルのパスを固定
      const fetchUrl = '/update/players.json';

      // 選手データを取得
      const res = await fetch(fetchUrl);
      if (!res.ok) throw new Error('JSONファイルの読み込みに失敗');
      const data = await res.json();
      const players = Array.isArray(data) ? data : [];

      // 位置ID → 位置名マッピング
      const positionMap = {
        1: '投手',
        2: '捕手',
        3: '内野手',
        7: '外野手',
        9: '監督',
      };

      // 位置名 → グループID（DOM要素のID）への変換
      const positionIdMap = {
        投手: 'pitcher',
        捕手: 'catcher',
        内野手: 'infielder',
        外野手: 'outfielder',
        監督: 'manager',
        その他: 'other',
      };

      // グループの表示順（タブ順）
      const orderedGroups = ['pitcher', 'catcher', 'infielder', 'outfielder', 'manager', 'other'];

      // プレイヤー名 → テーマID のマッピングを取得（data属性から）
      const themeMap = {};
      const themeNodes = document.querySelectorAll('#theme-mapping div');
      themeNodes.forEach((el) => {
        const nameRaw = el.dataset.name?.trim();
        const theme = el.dataset.theme?.trim();
        if (nameRaw && theme) {
          const nameKey = nameRaw.replace(/[\s\u3000]+/g, '');
          themeMap[nameKey] = theme;
        }
      });

      // 選手をグループごとに分類
      const groups = new Map();

      players.forEach((player) => {
        const posName = positionMap[player.position] || 'その他';
        const groupId = positionIdMap[posName] || 'other';
        const playerNameKey = player.name.replace(/[\s\u3000]+/g, '');
        const themeId = themeMap[playerNameKey];
        if (!themeId) return; // テーマIDが無ければスキップ

        if (!groups.has(groupId)) {
          groups.set(groupId, []);
        }

        groups.get(groupId).push({
          player,
          themeId,
          posName,
        });
      });

      // 表示領域をクリア
      container.innerHTML = '';

      // --------------------------
      // カテゴリーナビゲーション作成
      // --------------------------

      const tabHeader = document.createElement('div');
      tabHeader.className = 'tab-header';

      const categoryBlock = document.createElement('div');
      categoryBlock.className = 'category-block';

      const title = document.createElement('p');
      title.className = 'category-title over-wrap';
      title.textContent = 'カテゴリー';

      const buttonList = document.createElement('div');
      buttonList.className = 'button-list';

      // 各ポジションごとにタブを作成
      orderedGroups.forEach((groupId) => {
        const group = groups.get(groupId);
        if (!group || group.length === 0) return;

        const a = document.createElement('a');
        a.className = 'tab-button hf-text-center';
        a.href = `#${groupId}`;
        a.textContent = group[0].posName;
        buttonList.appendChild(a);
      });

      categoryBlock.appendChild(title);
      categoryBlock.appendChild(buttonList);
      tabHeader.appendChild(categoryBlock);
      container.appendChild(tabHeader);

      // --------------------------
      // 選手リスト出力
      // --------------------------

      orderedGroups.forEach((groupId) => {
        const group = groups.get(groupId);
        if (!group || group.length === 0) return;

        // 背番号順にソート
        group.sort((a, b) => {
          const numA = parseInt(a.player.playerNumber, 10);
          const numB = parseInt(b.player.playerNumber, 10);
          return numA - numB;
        });

        // グループごとのブロック生成
        const groupDiv = document.createElement('div');
        groupDiv.id = groupId;
        groupDiv.className = 'players-list over-wrap';

        const heading = document.createElement('h2');
        heading.className = 'title-h2';
        heading.textContent = group[0].posName;
        groupDiv.appendChild(heading);

        const ul = document.createElement('ul');
        groupDiv.appendChild(ul);

        // 各選手の表示（リンク付き）
        group.forEach(({ player, themeId }) => {
          const li = document.createElement('li');
          li.innerHTML = `
            <a href="/goods_list.php?theme_id=${themeId}">
              <div class="image">
                <img src="${player.image}" width="100" alt="${player.name}">
              </div>
              <p><span>#${player.playerNumber}</span>${player.name}</p>
            </a>
          `;
          ul.appendChild(li);
        });

        container.appendChild(groupDiv);
      });
    } catch (error) {
      console.error('選手情報の取得に失敗:', error);
    }
  }

  // 実行
  setTimeout(() => {
    fetchPlayers();
  }, 500);
};
